import { AxiosAdapter } from '../../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getPages(pharmacy, page, section) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.MIGRATION_PHAROL}/carousel-product/list-v2/${Enviroment.COUNTRY}/${pharmacy}/${section}`,
			params: { page: page },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async updateIsPageActive(body) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.MIGRATION_PHAROL}/carousel-product/update-is-page-active`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
